module.exports = __webpack_public_path__ + "assets/img/fc4bb2f59842da8fbe318f5d2f298746.png";